import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { COLORS } from '../../styles/colors';

const ExercisePlaceholder = ({short, show}) => {

  if (short) {
    return (
      <div style={{
        backgroundColor: 'rgba(226,237,255,0.5)',
        padding: 10
      }}>
        <div style={{
          color: COLORS.grey,
          height: 150,
          width: '100%',
          display: 'flex',
          border: '1px solid grey',
          borderStyle: 'dashed',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column'
        }}>
          <FontAwesomeIcon icon="plus-square"
            style={{color: COLORS.grey, fontSize: '8em', padding: 10}}/>
          <b>DRAG EXERCISES HERE</b>
        </div>
      </div>
    )
  }else{
    if (!show) {
      return null;
    }
    return (
      <div style={{
        backgroundColor: 'rgba(226,237,255,0.5)',
        padding: 10
      }}>
        <div style={{
          color: COLORS.grey,
          height: 500,
          width: '100%',
          display: 'flex',
          border: '1px solid grey',
          borderStyle: 'dashed',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column'
        }}>
          <FontAwesomeIcon icon="plus-square"
            style={{color: COLORS.grey, fontSize: '10em', padding: 25}}/>
          <b>ADD EXERCISES HERE</b>
          <span style={{width: 200, textAlign: 'center'}}>Simply drag and drop exercises in desired sequence</span>
        </div>
      </div>
    )
  }

}

export default ExercisePlaceholder



// WEBPACK FOOTER //
// ./src/components/workouts/ExercisePlaceholder.js